module.exports = __webpack_public_path__ + "static/sunflowerPoly-73787d4ab077d49723b35473e0171c51.png";